var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isViewOnly)?_c('v-chip',{staticClass:"ml-2",attrs:{"color":"error","small":""}},[_vm._v(" View Only ")]):_vm._e(),(_vm.isConverted)?_c('v-chip',{staticClass:"ml-2",attrs:{"color":"warning","small":""}},[_vm._v(" Converted ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }